var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket-memberships"},_vm._l((_vm.basketItemsData),function(product,index){return _c('BasketItem',{key:`product${index}`,attrs:{"data":product},on:{"remove":_vm.onRemove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }